import { render, staticRenderFns } from "./PurPT_Details.vue?vue&type=template&id=50a26d22"
import script from "./PurPT_Details.vue?vue&type=script&lang=js"
export * from "./PurPT_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports